import React from 'react';
import CPPUtils from 'services/CPPUtils';
import Icon from 'components/Utils/NewIcon/index';
import { setFormValues } from 'hooks/useReduxForm';
import { useAppDispatch } from 'careand-redux/useAppDispatch';

const ACTIVE_TAB = 'immunizations';

interface CPPTimelineImmunizationProps {
  immunization: any;
  patient: any;
  onClick?: () => void;
  setActiveCPPTab: (tab: string) => void;
}

const CPPTimelineImmunization = ({
  immunization,
  patient,
  onClick,
  setActiveCPPTab,
}: CPPTimelineImmunizationProps) => {
  const dispatch = useAppDispatch();

  function editCPPItem() {
    let data = immunization.value;
    setActiveCPPTab(ACTIVE_TAB);
    const formName = CPPUtils.getFormName(ACTIVE_TAB, patient.id);
    dispatch(setFormValues({ formName, values: { ...data, itemId: immunization.id } }));
  }

  return (
    <div
      className="item-wrapper clickable"
      data-tip
      data-for={immunization.id}
      onClick={editCPPItem}
    >
      <div className="top-bar">
        <Icon src="vial-virus" />
        <span className="small-title">Immunization</span>
      </div>
      <div className="item-content">
        <span>{CPPUtils.getImmunizationDescription(immunization.value)}</span>
      </div>
    </div>
  );
};

export default CPPTimelineImmunization;
